<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-user"></i> 代理员工列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 - 优化布局 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">员工姓名/手机号</span>
            <el-input 
              v-model="searchForm.keywords" 
              placeholder="请输入姓名或手机号"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">所属部门</span>
            <el-cascader
              v-model="searchForm.department_id"
              :props="{ value: 'id', label: 'name', checkStrictly: true, emitPath: false }"
              :options="departmentData"
              placeholder="请选择部门"
              clearable
              size="small"
              class="department-cascader"
            ></el-cascader>
          </div>
          <div class="search-actions">
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
            <el-button type="success" @click="addData" icon="el-icon-plus" size="small">新增员工</el-button>
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-user"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">员工总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon male">
            <i class="el-icon-male"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ maleCount }}</div>
            <div class="stat-label">男性</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon female">
            <i class="el-icon-female"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ femaleCount }}</div>
            <div class="stat-label">女性</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon active">
            <i class="el-icon-check"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ activeCount }}</div>
            <div class="stat-label">在岗员工</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="员工信息" min-width="200">
            <template slot-scope="scope">
              <div class="employee-info">
                <div class="employee-name">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ scope.row.name_cn || '-' }}</span>
                </div>
                <div class="employee-dept">
                  <i class="el-icon-office-building"></i>
                  <span>{{ scope.row.department ? scope.row.department.name : '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="基本信息" width="140" align="center">
            <template slot-scope="scope">
              <div class="basic-info">
                <div class="gender">
                  <i :class="scope.row.sex == 1 ? 'el-icon-male' : (scope.row.sex == 0 ? 'el-icon-female' : 'el-icon-user')"></i>
                  <span>{{ scope.row.sex == 1 ? '男' : (scope.row.sex == 0 ? '女' : '-') }}</span>
                </div>
                <div class="age">
                  <i class="el-icon-cake"></i>
                  <span>{{ scope.row.id_code | parseIDCard }}岁</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="联系方式" width="130" align="center">
            <template slot-scope="scope">
              <div class="contact-info">
                <div class="mobile">
                  <i class="el-icon-phone"></i>
                  <span>{{ scope.row.mobile || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="工作状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.work_status == 1 ? 'success' : 'info'" size="small" effect="plain">
                {{ scope.row.work_status == 1 ? '在岗' : (scope.row.work_status == 0 ? '离岗' : '-') }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="社保状况" width="100" align="center">
            <template slot-scope="scope">
              <span class="insurance-status">{{ scope.row.insurance_status || '-' }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="证书数量" width="90" align="center">
            <template slot-scope="scope">
              <span class="cert-count">{{ scope.row.cert_count || 0 }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="创建时间" width="160" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="280" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="view-btn" @click="goInfo(scope.row)">
                <i class="el-icon-view"></i> 查看
              </el-button>
              <el-button type="text" size="small" class="edit-btn" @click="goEdit(scope.row)">
                <i class="el-icon-edit-outline"></i> 修改
              </el-button>
              <el-button type="text" size="small" class="cert-btn" @click="addCert(scope.row)">
                <i class="el-icon-medal"></i> 证书
              </el-button>
              <el-button type="text" size="small" class="delete-btn" @click="goDel(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-user"></i>
        <p>暂无员工数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "proxyEmployeeList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        keywords: "",
        department_id: ''
      },
      
      // 统计数据
      maleCount: 0,
      femaleCount: 0,
      activeCount: 0,
      
      // 部门数据
      departmentData: [],
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      showType: ''
    }
  },
  created() {
    this.DataList()
    this.DepartmentList()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    },
    parseIDCard(idCard) {
      if (!idCard) return '-'
      const reg = /^\d{17}[\dXx]$/
      if (reg.test(idCard)) {
        const birthday = idCard.substring(6, 14)
        const year = birthday.substring(0, 4)
        const currentYear = new Date().getFullYear()
        return currentYear - parseInt(year)
      }
      return '-'
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 计算统计数据
    calculateStats() {
      if (!this.tableLoadData || this.tableLoadData.length === 0) {
        this.maleCount = 0
        this.femaleCount = 0
        this.activeCount = 0
        return
      }
      this.maleCount = this.tableLoadData.filter(item => item.sex == 1).length
      this.femaleCount = this.tableLoadData.filter(item => item.sex == 0).length
      this.activeCount = this.tableLoadData.filter(item => item.work_status == 1).length
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        keywords: "",
        department_id: ''
      }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    // 获取部门列表
    DepartmentList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      this.$axios.departmentTree(param).then(res => {
        if (res.code == 200) {
          this.departmentData = res.data || []
        }
      }).catch(error => {
        console.log(error)
      })
    },
    
    // 获取员工列表
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: sessionStorage.getItem('shop_id'),
        proxy_id: sessionStorage.getItem('proxy_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      if (this.searchForm.keywords) {
        param.keywords = this.searchForm.keywords
      }
      if (this.searchForm.department_id) {
        param.department_id = this.searchForm.department_id
      }
      
      this.$axios.proxyEmployeeListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    // 新增员工
    addData() {
      this.$router.push('/proxyEmployeeForm')
    },
    
    // 查看详情
    goInfo(row) {
      this.$router.push({
        path: '/proxyEmployeeInfo',
        query: { id: row.id }
      })
    },
    
    // 编辑员工
    goEdit(row) {
      this.$router.push({
        path: '/proxyEmployeeForm',
        query: { id: row.id }
      })
    },
    
    // 添加证书
    addCert(row) {
      this.$router.push({
        path: '/employeeCertificateList',
        query: { employee_id: row.id }
      })
    },
    
    // 删除员工
    goDel(row) {
      this.$confirm(`确定要删除员工"${row.name_cn}"吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: row.id,
        }
        this.$axios.proxyEmployeeDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.pageNum = 1
            this.DataList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .search-label {
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
      min-width: 110px;
      text-align: right;
    }
    
    .search-input { width: 220px; }
    .department-cascader { width: 200px; }
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    margin-left: auto;
    
    .el-button { border-radius: 20px; padding: 8px 18px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; border-color: #1acd8c; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 130px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.male { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.female { background: linear-gradient(135deg, #e6a23c, #ebb563); }
      &.active { background: linear-gradient(135deg, #ef705a, #ff8c6f); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.employee-info {
  .employee-name { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #1677ff; font-size: 14px; } span { font-weight: 500; } }
  .employee-dept { display: flex; align-items: center; gap: 6px; i { color: #e6a23c; font-size: 12px; } span { font-size: 12px; color: #8c8f98; } }
}

.basic-info {
  .gender, .age { display: flex; align-items: center; gap: 4px; justify-content: center; i { font-size: 12px; } }
  .gender i { &.el-icon-male { color: #00b578; } &.el-icon-female { color: #e6a23c; } }
  .age i { color: #909399; }
}

.contact-info { .mobile { display: flex; align-items: center; gap: 6px; justify-content: center; i { color: #00b578; } } }
.insurance-status { color: #606266; }
.cert-count { font-weight: 600; color: #1677ff; font-size: 16px; }
.time-text { font-size: 12px; color: #8c8f98; }

.view-btn { color: #909399; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #a6a9ad; } }
.edit-btn { color: #1677ff; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #4096ff; } }
.cert-btn { color: #e6a23c; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #ebb563; } }
.delete-btn { color: #ff4d4f; i { margin-right: 4px; } &:hover { color: #ff7875; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

@media (max-width: 1200px) {
  .search-bar .search-item .search-input { width: 180px; }
  .search-bar .search-item .department-cascader { width: 160px; }
}
</style>